// Memorial entry for Youssef and Hamza Ziyadne
import youssefZiyadnePortrait from '../../../images/youssef-ziyadne.jpg';
import hamzaZiyadnePortrait from '../../../images/hamza-ziyadne.jpg';

export const ziyadneFamilyMemorial = {
  id: 30,
  name: 'Youssef & Hamza Ziyadne',
  images: {
    youssef: youssefZiyadnePortrait,
    hamza: hamzaZiyadnePortrait
  },
  info: `
"I told them we were Arabs. They said to us, even though we're Arabs, they're kidnapping us." - Bilal Ziyadne, released hostage

# Youssef & Hamza Ziyadne

![Youssef Ziyadne](${youssefZiyadnePortrait})
*Youssef Ziyadne, 53, beloved father and community pillar*

![Hamza Ziyadne](${hamzaZiyadnePortrait})
*Hamza Ziyadne, 22, young father who loved horses and nature*

## Father and Son

Youssef Hamis Ziyadne, 53, and his son Hamza, 22, were Bedouin-Israelis from Rahat, the largest Bedouin city in Israel's Negev Desert. For 17 years, Youssef worked as a dairy farmer at Kibbutz Holit. Hamza had joined him five years earlier, working alongside his father in the cowshed.

Youssef was married with 19 children. His brother Ali described him as "a very beloved person" whose home was where "everyone gathers" - "a person who likes to bring peace... the gentleman" who "was always dressed like he was going to a wedding. He really loved life."

Hamza was a young father of two, beloved by his friends. He loved horses and nature, and the family had bought him a horse as a homecoming gift for when he returned from captivity - a gift he would never receive.

## October 7, 2023

That morning, Youssef was working the night shift with three of his children: Hamza (22), Bilal (18), and Aisha (17). When rockets began falling, the family sought shelter in the kibbutz bomb shelter.

Hamas terrorists found them there. Bilal later testified: "I told them we were Arabs. They said to us, even though we're Arabs, they're kidnapping us."

All four were taken to Gaza.

## A Family Divided

In November 2023, during a temporary ceasefire, Bilal and Aisha were released. But Youssef and Hamza were not. The family never understood why Hamas kept the father and older brother while releasing the younger siblings.

"Nobody believed us something like this happened," Ali said. "I don't understand why they didn't bring them back with Bilal and Aisha. They didn't take into consideration at all that they are Muslim."

## Tragedy Upon Tragedy

The cruelty ran deeper still. Hamza's mother is from the West Bank, and during the war, her sister and some of her children were killed in Israeli bombardment in Khan Yunis - the same area where Hamza was being held hostage. The family grieved on both sides of the border.

## Found Together

On January 7, 2025, the IDF recovered Youssef and Hamza's remains from a tunnel in southern Gaza's Rafah area. They were found alongside Hamas operatives believed to be their guards. Evidence suggests they were killed approximately a year before discovery.

Youssef was buried on January 9, 2025, with thousands in attendance. Hamza followed on January 10. Rahat declared four days of mourning.

Their childhood friend and fellow former hostage Farhan al-Qadi wept: "Youssef, my friend, my neighbor, my childhood friend. He was a friend to everyone, a father to everyone, he doesn't deserve this — nobody does."

## A Community Mourns

An interfaith delegation of over 30 religious leaders visited the bereaved family. Ali spoke for them all: "We lost sons, it doesn't matter if they were Jewish or Muslim. They all have mothers and children waiting for them."

The family's story embodies the cruelest irony of October 7 - Arab Muslim Israeli citizens, taken by Hamas despite their identity, held while family members died on both sides of the conflict, forgotten by many in the international community.

What happened on October 7, as a relative said, "regardless of whether it was to Bedouins or Jews, is not allowed in Islam."

*They were fathers, sons, workers, neighbors. May their memory be a blessing.*

[Read more about the Ziyadne family](https://www.timesofisrael.com/youssef-and-hamza-ziyadne-53-22-father-and-son-dairy-farmers/)
`
};
